import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { urlRoutes } from '../../constants/url-route.constant';

@Injectable({
  providedIn: 'root'
})
export class UseridealService {
  private readonly LAST_ACTIVE_KEY = 'userLastActive';
  private readonly LAST_URL_KEY = 'lastActiveUrl';
  private idleTimer: any;
  private events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
  private timeoutInMinutes: number = 15;
  private readonly CHECK_INTERVAL = 5 * 1000;
  public userLoggedOut = new Subject<void>();
  private isInitialized = false;

  constructor(
    private ngZone: NgZone,
    private router: Router
  ) { }

  private setLastActive(timestamp: number): void {
    localStorage.setItem(this.LAST_ACTIVE_KEY, timestamp.toString());
  }

  private getLastActive(): number {
    return parseInt(localStorage.getItem(this.LAST_ACTIVE_KEY) || '0', 10);
  }

  init(timeoutInMinutes: number) {
    this.cleanup();
    
    this.timeoutInMinutes = timeoutInMinutes;
    this.isInitialized = true;
    this.resetTimer();
    this.startWatching();
    
    this.checkIdleStatus();
    this.storeCurrentUrl();
  }

  private cleanup(): void {
    if (this.idleTimer) {
      clearTimeout(this.idleTimer);
      this.idleTimer = null;
    }

    this.events.forEach(event => {
      document.removeEventListener(event, () => this.resetTimer());
    });
    
    this.isInitialized = false;
  }

  private startWatching(): void {
    this.events.forEach(event => {
      document.removeEventListener(event, () => this.resetTimer());
    });

    this.events.forEach(event => {
      document.addEventListener(event, () => {
        this.resetTimer();
        this.storeCurrentUrl();
      });
    });
  }

  private storeCurrentUrl(): void {
    const currentUrl = window.location.pathname + window.location.search;
    localStorage.setItem(this.LAST_URL_KEY, currentUrl);
  }

  private getStoredUrl(): string {
    return localStorage.getItem(this.LAST_URL_KEY) || '/dashboard';
  }

  resetTimer() {
    if (!this.isInitialized) {
      return;
    }

    this.ngZone.run(() => {
      if (this.idleTimer) {
        clearTimeout(this.idleTimer);
      }
      const now = new Date().getTime();
      this.setLastActive(now);
      
      this.idleTimer = setTimeout(() => {
        this.checkIdleStatus();
      }, this.CHECK_INTERVAL);
    });
  }

  checkIdleStatus(): void {
    if (!this.isInitialized) {
      return;
    }

    const lastActive = this.getLastActive();
    const now = new Date().getTime();
    const idleTime = now - lastActive;
    const timeoutInMs = this.timeoutInMinutes * 60 * 1000;
    
    if (idleTime >= timeoutInMs) {
      this.logout();
    } else {
      this.idleTimer = setTimeout(() => {
        this.checkIdleStatus();
      }, this.CHECK_INTERVAL);
    }
  }

  // private logout(): void {
  //   this.cleanup();
    
  //   this.userLoggedOut.next();
    
  //   const returnUrl = this.getStoredUrl();
    
  //   localStorage.removeItem('access_token');
  //   sessionStorage.clear();
  //   localStorage.clear();
    
  //   localStorage.setItem(this.LAST_URL_KEY, returnUrl);
    
  //   Swal.fire({
  //     title: 'Session Expired',
  //     text: 'You have been logged out due to inactivity. Please login again.',
  //     icon: 'warning',
  //     confirmButtonColor: 'red',
  //     confirmButtonText: 'Login Again',
  //     allowOutsideClick: false,
  //     showCancelButton: false
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       this.onLogout(returnUrl);
  //     }
  //   });
  // }

  private logout(): void {
    this.cleanup();
    
    this.userLoggedOut.next();
    
    const returnUrl = this.getStoredUrl();
    const currentUrl = window.location.pathname;
    const selectedDomainMails = localStorage.getItem('selected_domain_mails');
    
    // Clear storages
    localStorage.clear();
    sessionStorage.clear();
    
    // Restore selected_domain_mails if on mail-box page
    if (currentUrl.includes(urlRoutes.mail_box) && selectedDomainMails) {
        localStorage.setItem('selected_domain_mails', selectedDomainMails);
    }
    
    localStorage.setItem(this.LAST_URL_KEY, returnUrl);
    
    Swal.fire({
        title: 'Session Expired',
        text: 'You have been logged out due to inactivity. Please login again.',
        icon: 'warning',
        confirmButtonColor: 'red',
        confirmButtonText: 'Login Again',
        allowOutsideClick: false,
        showCancelButton: false
    }).then((result) => {
        if (result.isConfirmed) {
            this.onLogout(returnUrl);
        }
    });
}

  onLogout(returnUrl: string = '') {   
    this.router.navigate(
      ['/authentication/login'], 
      { queryParams: { returnUrl: returnUrl } }
    ).then(() => {
      this.destroy();
    });
  }

  destroy(): void {
    this.cleanup();
    localStorage.removeItem(this.LAST_URL_KEY);
  }
}